
import { useEffect } from 'react';

import { Layout } from '../../components';
import { DashboardPanel } from '../../components/panels';
import { DRAWER_KEYS } from '../../store/constants';

/**
 * Renders the Dashboard page.
 *
 * This component displays the Dashboard page, which includes an app bar, a drawer, and a dashboard panel.
 * The page title is set to "Dashboard | LCD".
 *
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered Dashboard page.
 */
const DashboardPage = () => {

    useEffect(() => {
        document.title = 'Dashboard | LCD'
    }, [])

    return (
        <Layout selectedKey={DRAWER_KEYS.DASHBOARD}>
            <DashboardPanel />
        </Layout>
    )
}

export default DashboardPage